import { forwardRef } from "react";
import { width, height } from "styled-system";
import styled from "styled-components";
import { KeyCode } from "../../enums/key-code";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledItem = styled.div.withConfig({
  displayName: "visual-menu-item__StyledItem",
  componentId: "sc-1o7g1z9-0"
})(["display:block;position:relative;border-radius:", "px;cursor:pointer;", " ", " &:hover,&:active{color:", ";}&:focus-visible{outline:0;box-shadow:inset 0 0 0 2px ", ";}&::before{content:\"\";display:block;position:absolute;background-color:", ";border-radius:3px;opacity:0;transition:transform 0.2s ", ",opacity 0.2s ", ";}&[data-orientation=\"vertical\"]{width:100%;padding:8px 16px;&::before{top:0;left:0;margin:5px 0;width:3px;height:calc(100% - 10px);transform:scaleY(0.0001);}}&[data-orientation=\"horizontal\"]{height:100%;padding:16px 8px;&::before{bottom:0;left:0;margin:0 5px;height:3px;width:calc(100% - 10px);transform:scaleX(0.0001);}}&[data-selected=\"true\"]{background:", ";color:", ";&::before{opacity:1;transition:transform 0.2s ", ",opacity 0.2s ", ";}&[data-orientation=\"vertical\"]::before{transform:scaleY(1);}&[data-orientation=\"horizontal\"]::before{transform:scaleX(1);}}"], p => p.theme.radii.base, width, height, p => p.theme.colors.primary.base, p => p.theme.colors.focus, p => p.theme.colors.primary.base, p => p.theme.transitions.easeOut, p => p.theme.transitions.easeOut, p => p.theme.colors.primary[0], p => p.theme.colors.primary.base, p => p.theme.transitions.easeInOut, p => p.theme.transitions.easeInOut);
const VisualMenuItem = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    eventKey,
    selected,
    onSelect,
    orientation,
    children,
    ...rest
  } = _ref;
  const onClick = event => {
    if (!selected && onSelect) {
      onSelect({
        key: eventKey,
        domEvent: event
      });
    }
  };
  const onKeyDown = event => {
    if (event.keyCode === KeyCode.ENTER) {
      onClick(event);
    }
  };
  return /*#__PURE__*/_jsx(StyledItem, {
    ref: ref,
    ...rest,
    tabIndex: 0,
    onClick: onClick,
    onKeyDown: onKeyDown,
    "data-orientation": orientation,
    "data-selected": selected,
    children: children
  });
});
export default VisualMenuItem;